import { signal } from "../store/signal.js";
class Controller {
    get isConnected() {
        return this._isConnected;
    }
    get props() {
        return this._props;
    }
    get container() {
        return this._container;
    }
    get children() {
        return this._children;
    }
    _setModuleRef(moduleRef) {
        this._moduleRef = moduleRef;
    }
    get moduleRef() {
        if (!this._moduleRef) throw new Error(`[Controller] ${this.constructor.name} moduleRef not set. Ensure controller is created via moduleRef.resolve().`);
        return this._moduleRef;
    }
    async resolve(token) {
        return this.moduleRef.resolve(token);
    }
    async resolveChild(token, key) {
        if (this._children.has(key)) return this._children.get(key);
        const child = await this.moduleRef.resolve(token);
        this._children.set(key, child);
        return child;
    }
    getChild(key) {
        return this._children.get(key);
    }
    removeChild(key) {
        const child = this._children.get(key);
        if (child) {
            child.destroy();
            this._children.delete(key);
            return true;
        }
        return false;
    }
    async connect(props, container) {
        if (this._isConnected) return void console.warn(`[Controller] ${this.constructor.name} is already connected. Call destroy() first before reconnecting.`);
        if (props) this._props = signal(props);
        if (container) this._container = container;
        this._isConnected = true;
    }
    destroy() {
        for (const [key, child] of this._children)try {
            child.destroy();
        } catch (error) {
            console.warn(`[Controller] Error destroying child '${key}' in ${this.constructor.name}:`, error);
        }
        this._children.clear();
        for (const cleanup of this._cleanupFns)try {
            cleanup();
        } catch (error) {
            console.warn(`[Controller] Error during cleanup in ${this.constructor.name}:`, error);
        }
        this._cleanupFns = [];
        this._props = null;
        this._container = null;
        this._isConnected = false;
    }
    registerCleanup(cleanup) {
        this._cleanupFns.push(cleanup);
    }
    addEventListener(target, event, handler, options) {
        target.addEventListener(event, handler, options);
        this.registerCleanup(()=>{
            target.removeEventListener(event, handler, options);
        });
    }
    onConnected() {}
    onBeforeDestroy() {}
    constructor(){
        this._isConnected = false;
        this._moduleRef = null;
        this._props = null;
        this._container = null;
        this._cleanupFns = [];
        this._children = new Map();
    }
}
export { Controller };
